export const Close = '/icons/icon-close.svg'
export const DebugAlt2 = '/icons/debug-alt-2.svg'
export const Ellipsis = '/icons/ellipsis.svg'
export const ExtensionDefaultIcon = '/icons/extensionDefaultIcon.png'
export const EXtensionLanguageBasics = '/icons/language-icon.svg'
export const Extensions = '/icons/extensions.svg'
export const ExtensionTheme = '/icons/theme-icon.png'
export const Files = '/icons/files.svg'
export const NextMatch = '/icons/arrow-down.svg'
export const PreviousMatch = '/icons/arrow-up.svg'
export const Search = '/icons/search.svg'
export const SettingsGear = '/icons/settings-gear.svg'
export const SourceControl = '/icons/source-control.svg'
export const SymbolDefault = 'IconDefault'
export const SymbolFunction = '/icons/symbol-method.svg'
export const SymbolKeyword = '/icons/symbol-keyword.svg'
export const SymbolProperty = '/icons/symbol-property.svg'
export const SymbolValue = '/icons/symbol-enum.svg'
export const SymbolVariable = '/icons/symbol-variable.svg'
